export default __webpack_public_path__ + "static/media/avatar5.0a8ca42b.jpg";